var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"action-button",class:{
      'background-green': _vm.color === 'green'
    },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }